import { apiCertificationsMaster } from './apiInstances';

// GET Error Message to InspectorExpertReviewModal
export const getErrorMessage = async (parteTrabajoDiarioId) => {
  try {
    const result = await apiCertificationsMaster.get(
      `/v1/SolicitudServicio/MensajesErrorSE?parteTrabajoDiarioId=${parteTrabajoDiarioId}`
    );

    return result.data;
  } catch (error) {
    throw new Error(error?.data?.message);
  }
};

// POST Autorizacion Manual, autorizar, rechazar, revalidar
export const postActionsInspector = async ({ action, errorId, parteDiarioCostoIds = [] }) => {
  const body = {
    parteDiarioCostoIds,
    errorId
  };

  try {
    const result = await apiCertificationsMaster.post(
      `/v1/SolicitudServicio/PartesDeTrabajo/Acciones/${action}`,
      body
    );

    return result.data;
  } catch (error) {
    throw new Error(error?.data?.message);
  }
};

/** @param {{idParteTrabajoDiario: number[]}} */

export const getUbicationDetails = async (idsPartesDiarios) => {
  const body = { idsPartesDiarios };
  const { data } = await apiCertificationsMaster.post(
    `/v1/parteTrabajo/vistaExtendida/pxq/detalle`,
    body
  );

  return data;
};

export const getImputationObjectsDetails = async (body) => {
  const bodyPost = {
    tipoAsignacionEnum: body?.tipoAsignacionEnum,
    fechaDesde: body?.fechaDesde,
    fechaHasta: body?.fechaHasta,
    ubicacionNombre: body?.ubicacionNombre
  };

  const result = await apiCertificationsMaster.post(
    `v1/SolicitudServicio/${body?.idSolicitud}/CostosPendientes/ObjetosImputacion`,
    bodyPost
  );

  return result.data;
};

export const postImputationObjects = async (body, id) => {
  const result = await apiCertificationsMaster.put(
    `v1/SolicitudesServicio/${id}/objetosImputacion`,
    body
  );

  return result.data;
};
